/* eslint-disable react-hooks/rules-of-hooks */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Row } from 'antd';
import dayjs from 'dayjs';
import { isEqual } from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { EObcanstviDruhDokladu, IAmlz, ISubjObcanstvi, ISubjPrilozenesoubory } from 'types/amlz';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import UploadComponent from 'components/atoms/UploadComponent';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';
import PhoneNumberInput from 'components/molecules/PhoneNumberInput';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import { EStavZadostAmlz } from 'services/spravaEmitenta/historickeZadosti';
import { EZadostPravoIdentifikace, ISubjPravo } from 'services/spravaEmitenta/zadostPravo';

import { EDownloadingStatus } from 'enums/amlz/downloadingStatus';
import { EIdentifikaceOsoby } from 'enums/amlz/identifikaceOsoby';
import { EPristupDepozitar } from 'enums/amlz/pristupDepozitar';
import { ETypSouboru } from 'enums/amlz/typSouboru';
import { EZastupujeOsoba } from 'enums/amlz/zastupujeOsoba';
import apiPaths from 'enums/apiPaths';
import { EProfilyTyp } from 'enums/profilyTyp';
import { phoneNumberRegExp } from 'enums/regExp';
import routePathEnum from 'enums/routePathEnum';

import {
    authSelect,
    authSelectAlt,
    c2stavSelectALL,
    druhdokladuSelect,
    identifikaceOsobySelect,
    pristupdepozitarSelect,
    zastupujeOsobaSelect
} from 'data/codebooks/amlz/c2selectData';

import getLanguageObject from 'utils/getLanguageObject';
import { cisloUctuValidation, kodBankyValidation, predcisliValidation } from 'utils/validations/bankUcetValidation';
import emailValidation from 'utils/validations/emailValidation';
import ibanValidation from 'utils/validations/ibanValidation';
import pscValidation from 'utils/validations/pscValidation';
import rodneCisloValidation from 'utils/validations/rodneCisloValidation';

import OpravneniCheckboxy from './OpravneniCheckboxy';
import { UploadPropsStateHolder } from './UploadPropsStateHolder';

interface IAgendaAmlzFormular {
    mode: 'smsLogin' | 'zadostOOsoby' | 'zadostOAmlz' | 'zadostEdit' | 'C2' | 'displayOnly';
    apiList: (
        idZadosti: number | string,
        idOsoby: number | string,
        personObject: ISubjPravo
    ) => {
        downloadSignature: () => Promise<void>;
        pdfBiReroute: () => Promise<{
            redirect: string;
        } | void>;

        biReroute: () => Promise<{
            redirect: string;
        } | void>;
    };
    personData: ISubjPravo | undefined;
    // setPersonData: (value: ISubjPravo | undefined) => void;
    pdfCheckError: string;
    setPdfCheckError: React.Dispatch<React.SetStateAction<string>>;
    setPersonData?: React.Dispatch<React.SetStateAction<ISubjPravo | undefined>>;
    setSubmitPersonData: React.Dispatch<React.SetStateAction<ISubjPravo | undefined>>;
    setshowInstrukceAfterFinish: React.Dispatch<React.SetStateAction<boolean>>;
    idZadosti: number | undefined;
    // putResp?: string;
    setPersonDataFinish?: (value: boolean) => void;
    setRefetchTableData?: React.Dispatch<React.SetStateAction<boolean>>;
    setIsSubmittingManually?: React.Dispatch<React.SetStateAction<boolean>>;
    idOsoby?: number;
    isAmlzRequired?: boolean;
    isLegalEntity?: boolean;
    // auth: string | null;
}

const obcanstviEmpty = {
    cisdokladu: '',
    druhdokladu: undefined,
    platnostdo: '',
    stat: '',
    vydal: ''
};

const AgendaAmlzFormular: React.FC<IAgendaAmlzFormular> = ({
    personData,
    setSubmitPersonData,
    // setPersonData,
    idZadosti,
    setPersonDataFinish,
    setshowInstrukceAfterFinish,
    // putResp,
    idOsoby,
    mode,
    apiList,
    setPersonData,
    setRefetchTableData,
    isAmlzRequired,
    setIsSubmittingManually,
    pdfCheckError,
    setPdfCheckError,
    isLegalEntity
}) => {
    const { navigateWorkaround } = useNavigateWorkaround();
    const { confirm } = Modal;
    const [form] = Form.useForm();
    const { setLevel } = useProfily();
    const { cisStaty, language, amlz, aktivniFirma, zadostAgenda } = useContext(Context);
    const [showAuthEdit, setShowAuthEdit] = useState<boolean>(
        !!personData?.pristup?.puvodni && !!personData?.pristup?.novy ? true : false
    );
    const [loading, setLoading] = useState<boolean>(false);
    const [showMailModal, setShowMailModal] = useState<boolean>(false);
    const [mailModalText, setMailModalText] = useState<string>();
    const [statniObcanstvi, setStatniObcanstvi] = useState<ISubjObcanstvi[]>(
        personData?.obcanstvi?.length ? personData.obcanstvi : [{}]
    );
    const [downloadSignature, setDownloadSignature] = useState<boolean>(false);
    const [saving, setSaving] = useState<boolean>(false);
    const setForceRerender = useState<boolean>(false)[1];
    const ignoreFirstUpdate = useRef(true);
    const [
        elPodpisSoubor,
        dokladyTotozSoubory,
        zasOsobaSoubory,
        potvrzeniSoubory,
        dokladyTotozFileList,
        elPodpisFileList,
        setElPodpisFileList,
        setElPodpisSoubor,
        uploadPropsCert,
        certUploadResp,
        setCertUploadResp,
        showCertErr,
        downloading,
        setDownloading,
        showIdentifikaceUpload,
        setShowIdentifikaceUpload,
        showZastupujeUpload,
        setShowZastupujeUpload,
        RenderCertUpload,
        RenderElektPodpisUpload,
        RenderKopieDokladouTotoznostiUpload,
        RenderZastupujiciOsobaUpload,
        uploadStateReady,
        identifikaceOsobyElhasFileUploaded,
        fileList,
        setFileList
    ] = UploadPropsStateHolder(personData, idZadosti, mode, form, idOsoby, setPdfCheckError, isAmlzRequired);
    const isZadost = mode === 'zadostOOsoby' || mode === 'zadostOAmlz';
    const stavOdeslano =
        personData?.stav === EStavZadostAmlz.HOTOVO ||
        personData?.stav === EStavZadostAmlz.HOTOVOIIS ||
        personData?.stav === EStavZadostAmlz.CDCPKEKONTR ||
        personData?.stav === EStavZadostAmlz.ZAMITNUTO ||
        personData?.stav === EStavZadostAmlz.ZNEPLATNENO;
    const checkboxIsAllSelected: boolean =
        form.getFieldValue('opravneni') && form.getFieldValue('opravneni').includes('VSE');
    const isBankidLoginOk =
        form.getFieldValue('typprihlaseni') === 'BI' ||
        (personData?.pristup?.puvodni?.typprihlaseni === 'BI' && !form.getFieldValue('typprihlaseni'))
            ? form.getFieldValue('identifikaceosoby') === EZadostPravoIdentifikace.BI
            : true;

    const handleSelectChange = (name: string, value: string[] | string) => {
        if (typeof value === 'string') {
            form.setFieldsValue({
                [name]: value
            });
        } else {
            form.setFieldsValue({
                [name]: [...value]
            });
        }
        if (name === 'identifikaceosoby') {
            setShowIdentifikaceUpload(value as string);
            setDownloadSignature(false);
            setElPodpisFileList([]);
            setPdfCheckError('');
            statniObcanstvi.map((_, i) => form.validateFields([`druhdokladu${i}`]));
            (personData?.bisub || (personData?.ucet && value !== 'SC') || personData?.doplneno) &&
                setPersonData &&
                setPersonData(pv => {
                    const newState = {
                        ...pv
                    };
                    if (personData?.doplneno) delete newState.doplneno;
                    if (personData?.bisub) delete newState.bisub;
                    if (personData?.ucet && value !== 'SC') delete newState.ucet;
                    return newState;
                });
        }
        form.validateFields([name]);
        setForceRerender(val => !val); // update poli ktore sa renderuju po zmene selectu. asi ide spravit lepsie
    };

    useEffect(() => {
        if (!personData) return;
        setTimeout(
            () =>
                form.setFieldsValue({
                    typprihlaseni: personData?.pristup?.novy?.typprihlaseni,
                    ...(personData?.jmeno && {
                        jmeno: personData?.jmeno
                    }),
                    ...(personData?.prijmeni && {
                        prijmeni: personData?.prijmeni
                    }),
                    ...(personData?.datumnar && {
                        datumnar: personData?.datumnar ? dayjs(personData.datumnar) : null
                    }),
                    ...(personData?.email && {
                        email: personData?.email
                    }),
                    ...(personData?.telefon && {
                        telefon: phoneNumberRegExp.test(personData?.telefon) ? personData?.telefon : undefined
                    })
                }),
            0
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personData]);

    const onFinish = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        fieldsValue: any,
        secondaryAction?:
            | 'saveOnly'
            | 'showPlatInstrukce'
            | 'redirectBankSing'
            | 'redirectBiAmlz'
            | 'sendMail'
            | 'backBtnPressed'
            | 'deleteCertLogin'
    ) => {
        // format date value before submit.
        const values = {
            ...fieldsValue
        };

        const statneObcanstviSend = statniObcanstvi
            ?.filter((e, i) => !!Object.keys(e).length || !!values[`cisdokladu${i}`])
            .map((_e, i) => {
                // format statneho obcianstva pri osobe
                return {
                    cisdokladu: values[`cisdokladu${i}`],
                    druhdokladu: values[`druhdokladu${i}`],
                    ...(values[`druhdokladujiny${i}`] && {
                        druhdokladujiny: values[`druhdokladujiny${i}`]
                    }),
                    ...(values[`platnostdo${i}`] && {
                        platnostdo: values[`platnostdo${i}`].format('YYYY-MM-DD')
                    }),
                    stat: values[`stat${i}`],
                    vydal: values[`vydal${i}`]
                };
            });
        const personObject: ISubjPravo = {
            ...personData,
            jmeno: values.jmeno,
            prijmeni: values.prijmeni,
            stat: values.stat,
            misto: values.misto,
            ...((values.identifikaceosoby === 'BI' || personData?.identifikaceosoby === 'BI') &&
                personData?.bisub && {
                    bisub: personData.bisub
                }),
            ...((values.stat === 'CZ' || (personData?.bisub && values.idmb)) &&
                values.idmb && {
                    idmb: values.idmb
                }),
            ...(values.datumnar &&
                ((values.stat !== 'CZ' && !personData?.bisub) || (personData?.bisub && !values.idmb)) && {
                    datumnar: values.datumnar.format('YYYY-MM-DD')
                }),
            email: values.email,
            ...(values.telefon &&
                !values.telefon.includes('undefined') && {
                    telefon: values.telefon
                }),
            adma: values.adma,
            mema: values.mema,
            pscm: values.pscm,
            kost: values.kost,
            ...((statneObcanstviSend || []).length && {
                obcanstvi: statneObcanstviSend
            }),
            identifikaceosoby: values.identifikaceosoby,
            zastupuje: values.zastupuje,
            ...(values.pristupdepozitar && {
                pristupdepozitar: values.pristupdepozitar
            }),
            // datumztotozneni: values.datumztotozneni.format('YYYY-MM-DD'),
            prilozenesoubory: [
                ...(amlz?.goToC2Osoba ? personData?.prilozenesoubory || [] : []).filter(e =>
                    e.oblast
                        ? !['PLNAMOC', 'JINASMLOUVA', 'DOKLAD', 'PODEPSANYSOUBOR', 'UCET'].includes(e.oblast)
                        : true
                ),
                ...(showIdentifikaceUpload === EIdentifikaceOsoby.DOKLADY_TOTOZNOSTI
                    ? dokladyTotozSoubory
                    : elPodpisSoubor),
                ...zasOsobaSoubory.map((e: ISubjPrilozenesoubory) => {
                    return {
                        ...e,
                        oblast:
                            values.zastupuje === EZastupujeOsoba.FYZOSOBA_PLNAMOC
                                ? ETypSouboru.SOUBOR_PLNAMOC
                                : ETypSouboru.SOUBOR_JINASMLOUVA
                    };
                }),
                ...potvrzeniSoubory
            ],
            ...((personData?.pristup?.puvodni ||
                values.typprihlaseni ||
                (mode === 'smsLogin' && personData?.pristup?.novy)) && {
                pristup: {
                    ...personData?.pristup,
                    ...(values.typprihlaseni && {
                        novy: {
                            ...((values.identifikaceosoby === 'BI' || personData?.identifikaceosoby === 'BI') &&
                                personData?.bisub &&
                                (values.bankalogin || personData?.pristup?.novy?.biname) && {
                                    biname: values.bankalogin || personData?.pristup?.novy?.biname
                                }),
                            ...(values.typprihlaseni === 'CERT' &&
                                secondaryAction !== 'deleteCertLogin' && {
                                    certdn: certUploadResp?.dn || personData?.pristup?.novy?.certdn,
                                    certsn: certUploadResp?.serial || personData?.pristup?.novy?.certsn,
                                    certiss: certUploadResp?.issuer || personData?.pristup?.novy?.certiss
                                }),
                            typprihlaseni: values.typprihlaseni,
                            ...(values.typprihlaseni === 'PXKLIC' && {
                                username: values.email || personData?.pristup?.novy?.username
                            }),
                            ...(values.typprihlaseni === 'BI' && {
                                bisub: personData?.pristup?.novy?.bisub
                            })
                        }
                    })
                    // typprihlaseni: values.typprihlaseni
                    // id: values.typprihlaseniid
                }
            }),
            ...(values.identifikaceosoby === 'SC' && {
                ucet: {
                    ...personData?.ucet,
                    ...(values.predcisli && {
                        predcisli: values.predcisli
                    }),
                    ...(values.cislouctu && {
                        cislouctu: values.cislouctu
                    }),
                    ...(values.banka && {
                        banka: values.banka
                    }),
                    ...(values.iban && {
                        iban: values.iban.replaceAll(' ', '')
                    })
                }
            }),
            agenda: values?.opravneni?.map((e: string) => {
                return {
                    typ: e
                };
            }),
            stav: values?.stav,
            ...(mailModalText && {
                vyjadreni: mailModalText
            })
        };
        !values.typprihlaseni && mode !== 'smsLogin' && delete personObject.pristup?.novy;
        delete personObject.autprvek; // autprvek nemame vobec posielat ale nejako sa sem dostava

        if (downloadSignature) {
            // download elektronickeho podpisu
            setDownloading(EDownloadingStatus.ELEKTPODPIS);
            apiList(idZadosti!, idOsoby!, personObject)
                .downloadSignature()
                .finally(() => {
                    setDownloadSignature(false);
                    setDownloading('');
                });
        } else if (saving || secondaryAction) {
            // amlz PUT po uploade
            if (secondaryAction === 'deleteCertLogin') {
                ignoreFirstUpdate.current = true;
                setTimeout(() => {
                    setFileList([]);
                    setCertUploadResp(undefined);
                }, 0);
            }
            if (secondaryAction === 'showPlatInstrukce') {
                setshowInstrukceAfterFinish(true);
                setSubmitPersonData(personObject);
            } else if (secondaryAction === 'redirectBankSing') {
                setLoading(true);
                // setSubmitPersonData(personObject);
                setTimeout(
                    () =>
                        apiList(idZadosti!, idOsoby!, personObject)
                            .pdfBiReroute()
                            .then(resp => resp?.redirect && window.location.replace(resp.redirect))
                            .finally(() => setLoading(false)),
                    0
                );
            } else if (secondaryAction === 'redirectBiAmlz') {
                setLoading(true);
                //   setSubmitPersonData(personObject);
                setTimeout(
                    () =>
                        apiList(idZadosti!, idOsoby!, personObject)
                            .biReroute()
                            .then(resp => resp?.redirect && window.location.replace(resp.redirect))
                            .finally(() => setLoading(false)),
                    0
                );
            } else if (secondaryAction === 'sendMail') {
                setSubmitPersonData({
                    ...personObject,
                    ...(secondaryAction === 'sendMail' && {
                        stav: EStavZadostAmlz.UZIVEMAIL
                    })
                });
                secondaryAction === 'sendMail' &&
                    form.setFieldsValue({
                        stav: EStavZadostAmlz.UZIVCEKA
                    });
                setPersonData &&
                    setPersonData(pv => {
                        return {
                            ...pv,
                            stav: secondaryAction === 'sendMail' ? EStavZadostAmlz.UZIVCEKA : pv?.stav
                        };
                    });
            } else if (secondaryAction === 'saveOnly' || secondaryAction === 'deleteCertLogin') {
                mode === 'smsLogin' && setIsSubmittingManually && setIsSubmittingManually(true);
                setSubmitPersonData(personObject);
            } else if (secondaryAction === 'backBtnPressed') {
                Object.keys(personObject).forEach(
                    key =>
                        (personObject as { [key: string]: any })[key] === undefined &&
                        delete (personObject as { [key: string]: any })[key]
                );

                if (
                    !isEqual(personObject, {
                        ...personData,
                        obcanstvi: personData?.obcanstvi?.map(e => {
                            return {
                                ...e,
                                ...(e.platnostdo && {
                                    platnostdo: dayjs(e.platnostdo).format('YYYY-MM-DD')
                                })
                            };
                        })
                    }) &&
                    personData?.stav !== EStavZadostAmlz.HOTOVO &&
                    personData?.stav !== EStavZadostAmlz.HOTOVOIIS &&
                    personData?.stav !== EStavZadostAmlz.CDCPKEKONTR &&
                    personData?.stav !== EStavZadostAmlz.ZAMITNUTO &&
                    personData?.stav !== EStavZadostAmlz.ZNEPLATNENO
                ) {
                    confirm({
                        title: <TranslateText>AMLZ_AGENDA_MODAL_TITLTE</TranslateText>,
                        content: <TranslateText>AMLZ_AGENDA_MODAL_TEXT</TranslateText>,
                        cancelText: <TranslateText>NE</TranslateText>,
                        okText: <TranslateText>ANO</TranslateText>,
                        onOk() {
                            setIsSubmittingManually && setIsSubmittingManually(true);
                            setSubmitPersonData(personObject);
                            if (mode === 'zadostEdit') {
                                navigateWorkaround(-1);
                            }
                        },
                        onCancel() {
                            if (mode === 'zadostEdit') {
                                navigateWorkaround(-1);
                            } else if (mode === 'C2') {
                                setPersonData && setPersonData(undefined);
                                setRefetchTableData && setRefetchTableData(true);
                            }
                        }
                    });
                } else if (mode === 'zadostEdit') {
                    navigateWorkaround(-1);
                } else if (mode === 'C2') {
                    setPersonData && setPersonData(undefined);
                    setRefetchTableData && setRefetchTableData(true);
                }
            }

            setMailModalText(undefined);
            setShowMailModal(false);
            setSaving(false);
        } else {
            setPersonDataFinish && setPersonDataFinish(true);
            // setLoading(true);
            setSubmitPersonData({
                ...personObject,
                ...(isAmlzRequired && {
                    doplneno: true
                })
            });
            // zavrie componentu vrati sa na C2
        }
    };

    useEffect(() => {
        (mode === 'C2' || mode === 'zadostEdit') &&
            !personData?.stav &&
            form.setFieldsValue({
                stav: EStavZadostAmlz.ROZP
            });
        /*  ((personData?.identifikaceosoby === 'BI' && (mode === 'zadostOAmlz' || mode === 'zadostOOsoby')) ||
            amlz?.goToC2Osoba) &&
            uploadStateReady &&
            onFinish(form.getFieldsValue(), 'saveOnly'); */
        return () => {
            amlz?.goToC2Osoba &&
                setLevel('amlz', {
                    ...amlz,
                    goToC2Osoba: undefined
                } as IAmlz);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode]);

    useEffect(() => {
        // download elektronickeho podpisu || amlz PUT po uploade
        if (downloadSignature) {
            form.validateFields()
                .then(() => {
                    onFinish(form.getFieldsValue(), 'saveOnly');
                    setShowIdentifikaceUpload(EZadostPravoIdentifikace.EL);
                })
                .catch(e => {
                    if (e.errorFields.length) {
                        setDownloadSignature(false);
                        document.getElementById(e.errorFields[0].name[0])?.scrollIntoView();
                    } else {
                        onFinish(form.getFieldsValue(), 'saveOnly');
                        setShowIdentifikaceUpload(EZadostPravoIdentifikace.EL);
                    }
                });
        } else if (saving) {
            onFinish(form.getFieldsValue(), 'saveOnly');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [downloadSignature]);

    useEffect(() => {
        if (uploadStateReady) ignoreFirstUpdate.current = false;
    }, [uploadStateReady]);

    useEffect(() => {
        // amlz PUT po uploade
        if (
            !ignoreFirstUpdate.current &&
            uploadStateReady &&
            mode !== 'displayOnly' /* && !(pdfCheckError && pdfCheckError !== 'OK')*/
        ) {
            setSaving(true);
            onFinish(form.getFieldsValue(), 'saveOnly');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zasOsobaSoubory, dokladyTotozSoubory, elPodpisSoubor, potvrzeniSoubory, certUploadResp, uploadStateReady]);

    useEffect(() => {
        // odpoved kotnroly v put sluzbe
        if (pdfCheckError && pdfCheckError !== 'OK') {
            /*   setPdfCheckError(
                putResp === 'CERTOSOBA'
                    ? 'SOUBOR_CERTOSOBA_PODPIS'
                    : putResp === 'JINAOSOBA'
                    ? 'SOUBOR_JINAOSOBA_PODPIS'
                    : putResp === 'JINYSOUBOR'
                    ? 'SOUBOR_JINYSOUBOR_PODPIS'
                    : 'SOUBOR_CHYBA_PODPIS'
            ); */
            ignoreFirstUpdate.current = true;
            setElPodpisFileList([]);
            setElPodpisSoubor([]);
            setTimeout(() => {
                ignoreFirstUpdate.current = false;
            }, 1000);
        } // else if (putResp === 'OK') setPdfCheckError('');
        setDownloading('');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pdfCheckError]);

    const validateBeforeSubmit = (type?: 'redirectBiAmlz' | 'redirectBankSing') => {
        form.validateFields()
            .then(() => (type ? onFinish(form.getFieldsValue(), type) : form.submit()))
            .catch(errorInfo => {
                if (errorInfo.errorFields.length) {
                    if (['soubor', 'potvrzeni', 'sc', 'el'].includes(errorInfo.errorFields[0].name[0])) {
                        document.getElementById(errorInfo.errorFields[0].name[0])?.scrollIntoView();
                    }
                    form.scrollToField(errorInfo.errorFields[0].name);
                } else {
                    type ? onFinish(form.getFieldsValue(), type) : form.submit();
                }
            });
    };

    return (
        <LoadingWrapper
            loading={!cisStaty || loading || !!downloading}
            style={{
                width: '100%'
            }}
        >
            <FormWrapper
                name="ZadostoAgenduAmlz"
                outForm={form}
                onFinish={onFinish}
                scrollToFirstError={true}
                onFinishFailed={({ errorFields }) => {
                    form.scrollToField(errorFields[0].name[0]);
                }}
            >
                {/*            <Title level={5} dividerTitle={true} text={isLoginPage ? 'ZADOST_O_KOMUNIKACI' : 'ZAKLADNI_UDAJE_O_EMITENTOVI'} /> */}
                <InputComponent
                    disabled={
                        identifikaceOsobyElhasFileUploaded ||
                        mode === 'displayOnly' ||
                        (personData?.doplneno && (mode === 'C2' || mode === 'zadostEdit' ? !isAmlzRequired : true)) ||
                        stavOdeslano ||
                        isLegalEntity ||
                        personData?.bisub
                    }
                    label="FORMULARE_JMENA"
                    name="jmeno"
                    initialValue={personData?.jmeno}
                    type="text"
                    maxLength={100}
                />
                <InputComponent
                    disabled={
                        identifikaceOsobyElhasFileUploaded ||
                        mode === 'displayOnly' ||
                        (personData?.doplneno && (mode === 'C2' || mode === 'zadostEdit' ? !isAmlzRequired : true)) ||
                        stavOdeslano ||
                        isLegalEntity ||
                        personData?.bisub
                    }
                    label="FORMULARE_PRIJMENI"
                    name="prijmeni"
                    initialValue={personData?.prijmeni}
                    type="text"
                    maxLength={100}
                />
                <InputComponent
                    disabled={
                        identifikaceOsobyElhasFileUploaded ||
                        mode === 'displayOnly' ||
                        (mode !== 'C2' && mode !== 'zadostEdit' && mode !== 'zadostOAmlz') ||
                        stavOdeslano ||
                        isLegalEntity
                    }
                    label="EMAIL"
                    name="email"
                    initialValue={personData?.email}
                    type="text"
                    maxLength={100}
                    rules={emailValidation()}
                    onBlur={() =>
                        personData?.email && setTimeout(() => onFinish(form.getFieldsValue(), 'saveOnly'), 50)
                    }
                />
                <PhoneNumberInput
                    disabled={
                        identifikaceOsobyElhasFileUploaded ||
                        mode === 'displayOnly' ||
                        (mode !== 'C2' && mode !== 'zadostEdit' && mode !== 'zadostOAmlz') ||
                        stavOdeslano ||
                        isLegalEntity
                    }
                    label="TELEFON"
                    name="telefon"
                    initialValue={personData?.telefon}
                    maxLength={10}
                />
                {((mode !== 'zadostEdit' && mode !== 'C2') || personData?.identifikaceosoby || isAmlzRequired) && (
                    <SelectComponent
                        disabled={
                            isLegalEntity ||
                            // identifikaceOsobyElhasFileUploaded ||
                            mode === 'displayOnly' ||
                            stavOdeslano ||
                            ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                            (mode === 'smsLogin' && personData?.pristup?.novy?.typprihlaseni === 'BI')
                        }
                        name="identifikaceosoby"
                        isFormItem={true}
                        labelParagraph="FORMULARE_IDENTIFIKACE_OSOBA"
                        defaultValue={
                            isLegalEntity
                                ? EZadostPravoIdentifikace.BI
                                : mode === 'smsLogin' && personData?.pristup?.novy?.typprihlaseni === 'BI'
                                  ? EZadostPravoIdentifikace.BI
                                  : personData?.identifikaceosoby !== ('BISIGN' as EZadostPravoIdentifikace)
                                    ? personData?.identifikaceosoby
                                    : undefined
                        }
                        onChange={val => {
                            form.setFieldsValue({
                                typprihlaseni: undefined
                            });
                            handleSelectChange('identifikaceosoby', val);
                            elPodpisFileList.length
                                ? (setElPodpisFileList([]), setPdfCheckError(''), setElPodpisSoubor([]))
                                : setTimeout(() => onFinish(form.getFieldsValue(), 'saveOnly'), 50);
                        }}
                        data={identifikaceOsobySelect}
                    />
                )}
                {form.getFieldValue('identifikaceosoby') &&
                    form.getFieldValue('identifikaceosoby') === EZadostPravoIdentifikace.SC && (
                        <>
                            {/* CZ plati bez DPH 150 pre ostatne krajiny */}
                            {mode !== 'displayOnly' && (
                                <Paragraph
                                    text="C2_OSOBA_DOKLADY_TOTOZ_TEXT"
                                    translateParams={[
                                        (mode === 'smsLogin' ? zadostAgenda?.pristupc2?.stat : aktivniFirma?.stat) ===
                                        'CZ'
                                            ? '150'
                                            : '123,96'
                                    ]}
                                />
                            )}
                            <Title level={5} dividerTitle={true} text="UCET_EMITENT" />
                            <InputComponent
                                disabled={
                                    identifikaceOsobyElhasFileUploaded ||
                                    mode === 'displayOnly' ||
                                    ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                    ((mode === 'smsLogin' || isZadost || isAmlzRequired) && !!dokladyTotozSoubory.length
                                        ? false
                                        : personData?.doplneno) ||
                                    stavOdeslano
                                }
                                label="PREDCISLI_UCTU"
                                name="predcisli"
                                initialValue={personData?.ucet?.predcisli ? personData.ucet?.predcisli : ''}
                                notRequired={true}
                                maxLength={6}
                                rules={predcisliValidation()}
                            />
                            <InputComponent
                                disabled={
                                    identifikaceOsobyElhasFileUploaded ||
                                    mode === 'displayOnly' ||
                                    ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                    ((mode === 'smsLogin' || isZadost || isAmlzRequired) && !!dokladyTotozSoubory.length
                                        ? false
                                        : personData?.doplneno) ||
                                    stavOdeslano
                                }
                                label="CISLO_UCTU"
                                name="cislouctu"
                                initialValue={personData?.ucet?.cislouctu ? personData.ucet?.cislouctu : ''}
                                maxLength={10}
                                rules={cisloUctuValidation()}
                            />
                            <InputComponent
                                disabled={
                                    identifikaceOsobyElhasFileUploaded ||
                                    mode === 'displayOnly' ||
                                    ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                    ((mode === 'smsLogin' || isZadost || isAmlzRequired) && !!dokladyTotozSoubory.length
                                        ? false
                                        : personData?.doplneno) ||
                                    stavOdeslano
                                }
                                label="CISLO_BANKY"
                                name="banka"
                                initialValue={personData?.ucet?.banka ? personData.ucet?.banka : ''}
                                maxLength={4}
                                rules={kodBankyValidation()}
                            />
                            <InputComponent
                                disabled={
                                    identifikaceOsobyElhasFileUploaded ||
                                    mode === 'displayOnly' ||
                                    ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                    ((mode === 'smsLogin' || isZadost || isAmlzRequired) && !!dokladyTotozSoubory.length
                                        ? false
                                        : personData?.doplneno) ||
                                    stavOdeslano
                                }
                                label="IBAN"
                                infoTooltipText="ISIN_IDENTIFIKACE_VLASTNIK_HELP"
                                name="iban"
                                maxLength={34}
                                rules={ibanValidation()}
                                notRequired={true}
                                initialValue={personData?.ucet?.iban ? personData.ucet?.iban : ''}
                            />
                            <ButtonComponent
                                disabled={
                                    identifikaceOsobyElhasFileUploaded ||
                                    mode === 'displayOnly' ||
                                    ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                    ((mode === 'smsLogin' || isZadost || isAmlzRequired) && !!dokladyTotozSoubory.length
                                        ? false
                                        : personData?.doplneno) ||
                                    stavOdeslano
                                }
                                id="c2platInstrukceBtn"
                                buttontext="PLATEBNI_INSTRUKCE"
                                onClick={() => {
                                    form.validateFields(['cislouctu', 'banka'])
                                        .then(() => {
                                            onFinish(form.getFieldsValue(), 'showPlatInstrukce');
                                            setSaving(true);
                                        })
                                        .catch(errInfo => {
                                            if (!errInfo.errorFields.length) {
                                                onFinish(form.getFieldsValue(), 'showPlatInstrukce');
                                                setSaving(true);
                                            }
                                        });
                                }}
                                style={{
                                    marginTop: 14
                                }}
                                loading={downloadSignature}
                            />
                            {RenderCertUpload()}
                        </>
                    )}
                {((form.getFieldValue('identifikaceosoby') && form.getFieldValue('identifikaceosoby') !== 'BI') ||
                    personData?.kost ||
                    personData?.bisub) && (
                    <>
                        {form.getFieldValue('identifikaceosoby') === EZadostPravoIdentifikace.EL && (
                            <Paragraph text="ZADOST_PRAVO_IDENTIFIKACE_DOC_TEST" />
                        )}
                        <Title level={5} dividerTitle={true} text="Údaje osoby" />
                        <SelectComponent
                            isFormItem={true}
                            name="stat"
                            labelParagraph="FORMULARE_STAT_NAROZENI"
                            defaultValue={personData?.stat}
                            data={cisStaty ? cisStaty : []}
                            disabled={
                                identifikaceOsobyElhasFileUploaded ||
                                mode === 'displayOnly' ||
                                ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                ((mode === 'smsLogin' || isZadost || isAmlzRequired) && !!dokladyTotozSoubory.length
                                    ? false
                                    : personData?.doplneno) ||
                                stavOdeslano
                            }
                            onChange={() => {
                                setForceRerender(pv => !pv);
                                form.validateFields(['stat']);
                            }}
                        />
                        {
                            /* (!personData?.bisub || form.getFieldValue('identifikaceosoby') !== 'BI') && */
                            form.getFieldsValue(['stat']).stat === 'CZ' || (personData?.bisub && personData.idmb) ? (
                                <InputComponent
                                    disabled={
                                        identifikaceOsobyElhasFileUploaded ||
                                        mode === 'displayOnly' ||
                                        ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                        ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                        !!dokladyTotozSoubory.length
                                            ? false
                                            : personData?.doplneno) ||
                                        stavOdeslano
                                    }
                                    label="FORMULARE_RODNE_CISLO_CR"
                                    name="idmb"
                                    initialValue={personData?.idmb}
                                    type="text"
                                    maxLength={10}
                                    rules={rodneCisloValidation()}
                                />
                            ) : (
                                <DatePickerComponent
                                    disabled={
                                        identifikaceOsobyElhasFileUploaded ||
                                        mode === 'displayOnly' ||
                                        ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                        ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                        !!dokladyTotozSoubory.length
                                            ? false
                                            : personData?.doplneno) ||
                                        stavOdeslano
                                    }
                                    name="datumnar"
                                    label="FORMULARE_DATUM_NAROZENI"
                                    disabledDate={current => current > dayjs()}
                                    initialValue={personData?.datumnar ? dayjs(personData.datumnar) : undefined}
                                />
                            )
                        }
                        <InputComponent
                            label="FORMULARE_MISTO_NAROZENI"
                            name="misto"
                            initialValue={personData?.misto}
                            type="text"
                            maxLength={50}
                            disabled={
                                identifikaceOsobyElhasFileUploaded ||
                                mode === 'displayOnly' ||
                                ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                ((mode === 'smsLogin' || isZadost || isAmlzRequired) && !!dokladyTotozSoubory.length
                                    ? false
                                    : personData?.doplneno) ||
                                stavOdeslano
                            }
                        />
                        <Title level={5} dividerTitle={true} text="FORMULARE_ADRESA_POBYTU" />
                        {personData?.bisub && !personData?.adma ? (
                            <Paragraph text="AMLZ_C2_ADRESA_ERR" className="extramessage-text" />
                        ) : (
                            <>
                                <InputComponent
                                    label="ULICE_CP"
                                    name="adma"
                                    initialValue={personData?.adma}
                                    type="text"
                                    maxLength={50}
                                    disabled={
                                        identifikaceOsobyElhasFileUploaded ||
                                        mode === 'displayOnly' ||
                                        ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                        ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                        !!dokladyTotozSoubory.length
                                            ? false
                                            : personData?.doplneno) ||
                                        stavOdeslano
                                    }
                                />
                                <InputComponent
                                    label="MESTO"
                                    name="mema"
                                    initialValue={personData?.mema}
                                    type="text"
                                    maxLength={50}
                                    disabled={
                                        identifikaceOsobyElhasFileUploaded ||
                                        mode === 'displayOnly' ||
                                        ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                        ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                        !!dokladyTotozSoubory.length
                                            ? false
                                            : personData?.doplneno) ||
                                        stavOdeslano
                                    }
                                />
                                <InputComponent
                                    label="PSC"
                                    name="pscm"
                                    initialValue={personData?.pscm}
                                    type="text"
                                    maxLength={10}
                                    rules={pscValidation('kost')}
                                    usePscFormater={true}
                                    disabled={
                                        identifikaceOsobyElhasFileUploaded ||
                                        mode === 'displayOnly' ||
                                        ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                        ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                        !!dokladyTotozSoubory.length
                                            ? false
                                            : personData?.doplneno) ||
                                        stavOdeslano
                                    }
                                />

                                <SelectComponent
                                    isFormItem={true}
                                    name="kost"
                                    labelParagraph="STAT"
                                    defaultValue={personData?.kost}
                                    data={cisStaty ? cisStaty : []}
                                    disabled={
                                        identifikaceOsobyElhasFileUploaded ||
                                        mode === 'displayOnly' ||
                                        ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                        ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                        !!dokladyTotozSoubory.length
                                            ? false
                                            : personData?.doplneno) ||
                                        stavOdeslano
                                    }
                                    onChange={() => {
                                        setForceRerender(pv => !pv);
                                        form.validateFields(['kost']);
                                    }}
                                />
                            </>
                        )}
                        {(personData?.bisub ? !!personData?.obcanstvi?.length : true) &&
                            statniObcanstvi?.map((obcanstvi, i) => {
                                return (
                                    <div key={i}>
                                        <Title
                                            level={5}
                                            text="FORMULARE_STATNI_OBCANSTVI"
                                            style={{
                                                display: 'inline-block'
                                            }}
                                            dividerTitle={true}
                                        >
                                            {i === 0 && (
                                                <ButtonComponent
                                                    id="c2PlusAltBtn"
                                                    htmlType="button"
                                                    type="primary"
                                                    style={{
                                                        display: 'inline-block',
                                                        width: 50
                                                    }}
                                                    disabled={
                                                        identifikaceOsobyElhasFileUploaded ||
                                                        mode === 'displayOnly' ||
                                                        ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                                        ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                                        !!dokladyTotozSoubory.length
                                                            ? false
                                                            : personData?.doplneno) ||
                                                        stavOdeslano
                                                    }
                                                    icon={<PlusOutlined />}
                                                    onClick={() =>
                                                        setStatniObcanstvi(pv => {
                                                            if (pv) {
                                                                const newState = [...pv];
                                                                newState.push(obcanstviEmpty);
                                                                form.resetFields([
                                                                    `cisdokladu${pv.length}`,
                                                                    `druhdokladu${pv.length}`,
                                                                    `platnostdo${pv.length}`,
                                                                    `stat${pv.length}`,
                                                                    `vydal${pv.length}`
                                                                ]);
                                                                return newState;
                                                            }
                                                            return [{}];
                                                        })
                                                    }
                                                />
                                            )}
                                            {i === statniObcanstvi.length - 1 && statniObcanstvi.length > 1 && (
                                                <ButtonComponent
                                                    id="c2MinusBtn"
                                                    htmlType="button"
                                                    type="primary"
                                                    disabled={
                                                        identifikaceOsobyElhasFileUploaded ||
                                                        mode === 'displayOnly' ||
                                                        ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                                        ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                                        !!dokladyTotozSoubory.length
                                                            ? false
                                                            : personData?.doplneno) ||
                                                        stavOdeslano
                                                    }
                                                    style={{
                                                        display: 'inline-block',
                                                        width: 50
                                                    }}
                                                    icon={<MinusOutlined />}
                                                    onClick={() =>
                                                        setStatniObcanstvi(pv => {
                                                            if (pv) {
                                                                const newState = [...pv];
                                                                newState.splice(i, 1);
                                                                return newState;
                                                            }
                                                            return [{}];
                                                        })
                                                    }
                                                />
                                            )}
                                        </Title>

                                        <SelectComponent
                                            name={`stat${i}`}
                                            labelParagraph="STAT"
                                            isFormItem={true}
                                            defaultValue={obcanstvi.stat}
                                            data={cisStaty ? cisStaty : []}
                                            disabled={
                                                identifikaceOsobyElhasFileUploaded ||
                                                mode === 'displayOnly' ||
                                                ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                                ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                                !!dokladyTotozSoubory.length
                                                    ? false
                                                    : personData?.doplneno) ||
                                                stavOdeslano
                                            }
                                            onChange={() => {
                                                setForceRerender(pv => !pv);
                                                form.validateFields([`stat${i}`]);
                                            }}
                                        />
                                        <SelectComponent
                                            name={`druhdokladu${i}`}
                                            labelParagraph="FORMULARE_DRUH_DOKLADU"
                                            isFormItem={true}
                                            defaultValue={obcanstvi.druhdokladu}
                                            data={druhdokladuSelect}
                                            disabled={
                                                identifikaceOsobyElhasFileUploaded ||
                                                mode === 'displayOnly' ||
                                                ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                                ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                                !!dokladyTotozSoubory.length
                                                    ? false
                                                    : personData?.doplneno) ||
                                                stavOdeslano
                                            }
                                            onChange={() => {
                                                setForceRerender(pv => !pv);
                                            }}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
                                                },
                                                {
                                                    validator(_, value) {
                                                        try {
                                                            if (
                                                                form.getFieldValue('stat') === 'CZ' &&
                                                                form.getFieldValue('identifikaceosoby') ===
                                                                    EZadostPravoIdentifikace.EL &&
                                                                value !== EObcanstviDruhDokladu.OBCANKA &&
                                                                value !== EObcanstviDruhDokladu.PAS
                                                            )
                                                                return Promise.reject(
                                                                    <TranslateText>AGENDA_FORMULAR_OPPAS</TranslateText>
                                                                );
                                                            return Promise.resolve();
                                                        } catch {
                                                            return Promise.reject();
                                                        }
                                                    }
                                                }
                                            ]}
                                        />

                                        {form.getFieldValue(`druhdokladu${i}`) === EObcanstviDruhDokladu.JINE && (
                                            <InputComponent
                                                label="FORMULARE_DRUH_DOKLADU_JINY"
                                                name={`druhdokladujiny${i}`}
                                                initialValue={obcanstvi.druhdokladujiny}
                                                type="text"
                                                maxLength={500}
                                                disabled={
                                                    identifikaceOsobyElhasFileUploaded ||
                                                    mode === 'displayOnly' ||
                                                    ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                                    ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                                    !!dokladyTotozSoubory.length
                                                        ? false
                                                        : personData?.doplneno) ||
                                                    stavOdeslano
                                                }
                                            />
                                        )}
                                        <InputComponent
                                            label="FORMULARE_CISLO_DOKLADU"
                                            name={`cisdokladu${i}`}
                                            initialValue={obcanstvi.cisdokladu}
                                            type="text"
                                            maxLength={500}
                                            disabled={
                                                identifikaceOsobyElhasFileUploaded ||
                                                mode === 'displayOnly' ||
                                                ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                                ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                                !!dokladyTotozSoubory.length
                                                    ? false
                                                    : personData?.doplneno) ||
                                                stavOdeslano
                                            }
                                        />

                                        <InputComponent
                                            label="VYDAL"
                                            name={`vydal${i}`}
                                            initialValue={obcanstvi.vydal}
                                            type="text"
                                            maxLength={500}
                                            disabled={
                                                !!obcanstvi.vydal &&
                                                (identifikaceOsobyElhasFileUploaded ||
                                                    mode === 'displayOnly' ||
                                                    ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                                    ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                                    !!dokladyTotozSoubory.length
                                                        ? false
                                                        : personData?.doplneno) ||
                                                    stavOdeslano)
                                            }
                                        />

                                        {(() => {
                                            !!obcanstvi.platnostdo && form.validateFields([`platnostdo${i}`]);

                                            return null;
                                        })()}
                                        <DatePickerComponent
                                            name={`platnostdo${i}`}
                                            label="FORMULARE_DATUM_PLATNOSTI"
                                            disabled={
                                                identifikaceOsobyElhasFileUploaded ||
                                                mode === 'displayOnly' ||
                                                ((mode === 'zadostEdit' || mode === 'C2') && !isAmlzRequired) ||
                                                ((mode === 'smsLogin' || isZadost || isAmlzRequired) &&
                                                !!dokladyTotozSoubory.length
                                                    ? false
                                                    : personData?.doplneno) ||
                                                stavOdeslano
                                            }
                                            initialValue={obcanstvi.platnostdo ? dayjs(obcanstvi.platnostdo) : ''}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
                                                },
                                                {
                                                    validator(_, value) {
                                                        try {
                                                            if (dayjs(value) < dayjs())
                                                                return Promise.reject(
                                                                    <TranslateText>NEPLATNY_DATUM</TranslateText>
                                                                );
                                                            return Promise.resolve();
                                                        } catch {
                                                            return Promise.reject();
                                                        }
                                                    }
                                                }
                                            ]}
                                            disabledDate={current => current < dayjs()}
                                            defaultPickerValue={
                                                personData?.obcanstvi?.length
                                                    ? dayjs(personData.obcanstvi[0].platnostdo) > dayjs()
                                                        ? dayjs(personData.obcanstvi[0].platnostdo)
                                                        : dayjs()
                                                    : dayjs()
                                            }
                                            defaultValue={
                                                obcanstvi.platnostdo ? dayjs(obcanstvi.platnostdo) : undefined
                                            }
                                        />
                                    </div>
                                );
                            })}
                        {personData?.bisub && !personData?.obcanstvi?.length && (
                            <>
                                <Title level={5} dividerTitle={true} text="FORMULARE_STATNI_OBCANSTVI" />
                                <Paragraph text="AMLZ_C2_OBCANSTVI_ERR" className="extramessage-text" />
                            </>
                        )}
                    </>
                )}
                {mode !== 'smsLogin' && (
                    <>
                        <Title level={5} dividerTitle={true} text="DOPLNUJICI_INFORMACE" />
                        <SelectComponent
                            name="zastupuje"
                            labelParagraph={
                                isLegalEntity
                                    ? 'FORMULARE_ZASTUPUJICI_OSOBA_LEGALENTITY'
                                    : 'FORMULARE_ZASTUPUJICI_OSOBA'
                            }
                            validateTrigger="onSubmit"
                            isFormItem={true}
                            defaultValue={personData?.zastupuje}
                            disabled={
                                !(
                                    mode !== 'displayOnly' &&
                                    !stavOdeslano &&
                                    ((showIdentifikaceUpload === EZadostPravoIdentifikace.EL
                                        ? !personData?.doplneno
                                        : true) ||
                                        mode === 'C2' ||
                                        mode === 'zadostEdit')
                                )
                            }
                            onChange={value => {
                                setShowZastupujeUpload(String(value));
                                handleSelectChange('zastupuje', value);
                            }}
                            data={zastupujeOsobaSelect}
                        />
                        {showZastupujeUpload === EZastupujeOsoba.FYZOSOBA_PLNAMOC ||
                        showZastupujeUpload === EZastupujeOsoba.FYZOSOBA_JINEOPRAV
                            ? RenderZastupujiciOsobaUpload()
                            : null}

                        {!isLegalEntity && (
                            <SelectComponent
                                name="pristupdepozitar"
                                labelParagraph="ZADOST_PRISTUP"
                                validateTrigger="onSubmit"
                                isFormItem={true}
                                defaultValue={
                                    personData?.pristup?.puvodni || aktivniFirma?.typ === EProfilyTyp.ADMEMIT
                                        ? 'ANO'
                                        : personData?.pristupdepozitar
                                }
                                data={pristupdepozitarSelect}
                                disabled={
                                    aktivniFirma?.typ === EProfilyTyp.ADMEMIT ||
                                    !(
                                        mode !== 'displayOnly' &&
                                        !stavOdeslano &&
                                        ((showIdentifikaceUpload === EZadostPravoIdentifikace.EL
                                            ? !personData?.doplneno
                                            : true) ||
                                            mode === 'C2' ||
                                            mode === 'zadostEdit')
                                    )
                                }
                                onChange={val => {
                                    (val === EPristupDepozitar.NE || val === EPristupDepozitar.POZDEJI) &&
                                        form.resetFields(['typprihlaseni']);
                                    form.setFieldsValue({
                                        opravneni: form
                                            .getFieldValue('opravneni')
                                            .filter((e: string) => !['VSE', 'VYPIS', 'VIDETVYPIS', 'UPIS'].includes(e))
                                    });
                                    setForceRerender(pv => !pv);
                                    form.validateFields(['pristupdepozitar']);
                                }}
                            />
                        )}
                    </>
                )}
                {personData?.pristup?.puvodni && !isLegalEntity && (
                    <>
                        {(showAuthEdit || personData?.pristup?.novy) && <Title text="AUTH_PUVODNI" level={5} />}
                        <InputComponent
                            disabled={true}
                            label="AUTH_PRVEK"
                            notRequired={true}
                            name="autprvek"
                            // initialValue={getLanguageObject(language)[`TYP_PRIHLASENI_${personData.autprvek}`]}
                            initialValue={
                                getLanguageObject(language)[
                                    `TYP_PRIHLASENI_${personData?.pristup?.puvodni?.typprihlaseni}`
                                ]
                            }
                        />
                        {personData?.pristup?.puvodni.biname && (
                            <InputComponent
                                disabled={true}
                                notRequired={true}
                                label="BANK_USEDTO_LOGIN"
                                name="bankalogin"
                                initialValue={personData?.pristup?.puvodni?.biname /* || personData?.dn*/}
                            />
                        )}
                        {personData?.pristup?.puvodni.certdn /* || personData?.dn */ && (
                            <>
                                <InputComponent
                                    disabled={true}
                                    notRequired={true}
                                    label="CERTIFIKAT"
                                    name="dn"
                                    initialValue={personData?.pristup?.puvodni?.certdn /* || personData?.dn*/}
                                />
                                <InputComponent
                                    disabled={true}
                                    notRequired={true}
                                    label="VYSTAVITEL_CERTIFIKATU"
                                    name="issuer"
                                    initialValue={personData?.pristup?.puvodni?.certiss /* || personData?.issuer*/}
                                />
                            </>
                        )}
                        {mode !== 'displayOnly' &&
                            mode !== 'smsLogin' &&
                            !stavOdeslano &&
                            ((showIdentifikaceUpload === EZadostPravoIdentifikace.EL ? !personData?.doplneno : true) ||
                                mode === 'C2' ||
                                mode === 'zadostEdit') &&
                            (showAuthEdit ? (
                                <Button
                                    type="default"
                                    onClick={() => {
                                        setShowAuthEdit(false);
                                        form.resetFields(['typprihlaseni']);
                                        setPdfCheckError('');
                                        form.setFieldsValue({
                                            opravneni: form
                                                .getFieldValue('opravneni')
                                                .filter(
                                                    (e: string) => !['VSE', 'VYPIS', 'VIDETVYPIS', 'UPIS'].includes(e)
                                                )
                                        });
                                    }}
                                    id="c2zmenitauthbtnZpet"
                                    htmlType="button"
                                    style={{
                                        marginBottom: 16
                                    }}
                                >
                                    <TranslateText>ODEBRAT</TranslateText>
                                </Button>
                            ) : (
                                <ButtonComponent
                                    type="primary"
                                    htmlType="submit"
                                    onClick={() => setShowAuthEdit(true)}
                                    id="c2zmenitauthbtn"
                                    buttontext="ZMENIT"
                                />
                            ))}
                    </>
                )}
                {(showAuthEdit ||
                    (!personData?.pristup?.puvodni && form.getFieldValue('pristupdepozitar') === 'ANO') ||
                    (mode === 'smsLogin' && personData?.pristup?.novy?.typprihlaseni === 'CERT')) && (
                    <>
                        <Title text="AUTH_NOVY" level={5} />
                        {(form.getFieldValue('identifikaceosoby') &&
                            form.getFieldValue('identifikaceosoby') === EZadostPravoIdentifikace.BI) ||
                        ((mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired) ? null : (
                            <Paragraph
                                text="ZADOST_PRISTUP_AUTH_BI_TEXT"
                                style={{
                                    display: 'block'
                                }}
                            />
                        )}
                        <SelectComponent
                            disabled={
                                (showIdentifikaceUpload === EZadostPravoIdentifikace.EL &&
                                    !!elPodpisFileList.length &&
                                    (mode === 'zadostEdit'
                                        ? isAmlzRequired
                                        : mode === 'C2' && isAmlzRequired
                                          ? false
                                          : true)) ||
                                mode === 'displayOnly' ||
                                stavOdeslano ||
                                mode === 'smsLogin'
                            }
                            name="typprihlaseni"
                            labelParagraph={showAuthEdit ? 'ZADOST_PRISTUP_AUTH' : 'ZADOST_PRISTUP_AUTH_NEMA'}
                            isFormItem={true}
                            // defaultValue={personData?.pristup?.novy?.typprihlaseni}
                            data={
                                (form.getFieldValue('identifikaceosoby') &&
                                    form.getFieldValue('identifikaceosoby') === EZadostPravoIdentifikace.BI) ||
                                ((mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired)
                                    ? authSelect
                                    : authSelectAlt
                            }
                            onChange={() => {
                                setPdfCheckError('');
                                setForceRerender(pv => !pv);
                                form.validateFields(['typprihlaseni']);
                                setTimeout(() => onFinish(form.getFieldsValue(), 'saveOnly'), 50);
                            }}
                        />
                        {showAuthEdit && (
                            <Paragraph
                                text="ZADOST_PRISTUP_AUTH_TEXT"
                                style={{
                                    display: 'block'
                                }}
                            />
                        )}
                        {form.getFieldValue('typprihlaseni') === 'CERT' && (
                            <>
                                {!(
                                    !!certUploadResp ||
                                    !!personData?.pristup?.novy?.certdn ||
                                    ((mode === 'C2' || mode === 'zadostEdit') &&
                                        !isAmlzRequired &&
                                        personData?.doplneno)
                                ) && (
                                    <Form.Item
                                        style={{
                                            marginTop: 16,
                                            marginBottom: 16
                                        }}
                                        name="tempcert"
                                        label={<Paragraph text={'CERTIFIKAT'} strong={true} />}
                                        rules={[
                                            () => ({
                                                required:
                                                    (personData?.pristup?.puvodni?.typprihlaseni !== 'CERT' &&
                                                        !personData?.pristup?.novy?.certdn) ||
                                                    isAmlzRequired,
                                                validator() {
                                                    if (
                                                        (personData?.pristup?.puvodni?.typprihlaseni !== 'CERT' &&
                                                            !personData?.pristup?.novy?.certdn) ||
                                                        isAmlzRequired
                                                    ) {
                                                        if (showCertErr) {
                                                            //  setTimeout(() => form.validateFields(['tempcert']), 50);
                                                            return Promise.reject(
                                                                <TranslateText>DUVERNE_INF_ERR_401</TranslateText>
                                                            );
                                                        }
                                                        if (!fileList.length && !showCertErr)
                                                            return Promise.reject(
                                                                <TranslateText>
                                                                    NEVALIDNI_POVINNA_POLOZKA_UPLOAD
                                                                </TranslateText>
                                                            );
                                                        Promise.resolve();
                                                    } else {
                                                        return Promise.resolve();
                                                    }
                                                }
                                            })
                                        ]}
                                        validateTrigger="onChange"
                                    >
                                        <div
                                            style={{
                                                marginBottom: 22
                                            }}
                                        >
                                            {(mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired && (
                                                <Paragraph text={'AMLZ_CERT_TEXT'} />
                                            )}
                                            <UploadComponent
                                                {...uploadPropsCert}
                                                disabled={
                                                    (showIdentifikaceUpload === EZadostPravoIdentifikace.EL &&
                                                        !!elPodpisFileList.length &&
                                                        (mode === 'zadostEdit' || mode === 'C2'
                                                            ? !isAmlzRequired
                                                            : true)) ||
                                                    mode === 'displayOnly' ||
                                                    stavOdeslano
                                                }
                                                hideButton={(mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired}
                                                id="uzivatelUploadBtn"
                                                uploadPath={mode === 'smsLogin' ? apiPaths.FILE_UPLOAD_AMLODKAZ : ''}
                                                accept={'.pem, .dem, .cer, .der'}
                                            />
                                        </div>
                                    </Form.Item>
                                )}

                                {(certUploadResp || personData?.pristup?.novy?.certdn) && (
                                    <>
                                        <InputComponent
                                            disabled={true}
                                            notRequired={true}
                                            label="CERTIFIKAT"
                                            name="certdn"
                                            initialValue={certUploadResp?.dn || personData?.pristup?.novy?.certdn}
                                        />
                                        <InputComponent
                                            disabled={true}
                                            notRequired={true}
                                            label="VYSTAVITEL_CERTIFIKATU"
                                            name="certiss"
                                            initialValue={certUploadResp?.issuer || personData?.pristup?.novy?.certiss}
                                        />
                                        <ButtonComponent
                                            id="c2removeCert"
                                            buttontext="ODSTRANIT"
                                            disabled={mode === 'displayOnly' || personData?.doplneno || stavOdeslano}
                                            onClick={() => {
                                                onFinish(form.getFieldsValue(), 'deleteCertLogin');
                                            }}
                                            style={{
                                                marginTop: -14
                                            }}
                                        />
                                    </>
                                )}
                            </>
                        )}
                        {personData?.pristup?.novy?.biname && (
                            <InputComponent
                                disabled={true}
                                notRequired={true}
                                label="BANK_USEDTO_LOGIN"
                                name="bankalogin"
                                initialValue={personData?.pristup?.novy?.biname /* || personData?.dn*/}
                            />
                        )}
                    </>
                )}
                {personData?.zmenapristupu && personData?.zmenapristupu !== 'NOVYJEDENUCET' && (
                    <Paragraph
                        text={`AMLZ_C2_UCTY_MSG_${personData?.zmenapristupu}`}
                        style={{
                            display: 'block',
                            fontWeight: 'bold'
                        }}
                    />
                )}
                {mode !== 'smsLogin' && !isLegalEntity && (
                    <OpravneniCheckboxy
                        onChange={val => {
                            val.includes('VSE') &&
                                form.setFieldsValue({
                                    opravneni: ['VSE']
                                });
                            setForceRerender(pv => !pv);
                        }}
                        initialValue={personData?.agenda?.length ? [...personData.agenda!.map(e => e.typ)] : []}
                        disabled={
                            !(
                                mode !== 'displayOnly' &&
                                !stavOdeslano &&
                                ((showIdentifikaceUpload === EZadostPravoIdentifikace.EL
                                    ? !personData?.doplneno
                                    : true) ||
                                    mode === 'C2' ||
                                    mode === 'zadostEdit')
                            )
                        }
                        checkboxIsAllSelected={checkboxIsAllSelected}
                        mode={mode}
                        isAmlzRequired={isAmlzRequired && mode !== 'zadostEdit'}
                        enableAdvancedOptions={
                            !!(
                                personData?.pristup?.puvodni?.typprihlaseni &&
                                ['PXKLIC', 'CERT', 'BI'].includes(personData?.pristup?.puvodni?.typprihlaseni)
                            ) ||
                            // !!personData?.pristup?.novy?.typprihlaseni ||
                            !!form.getFieldValue('typprihlaseni')
                        }
                        formValue={form.getFieldValue('opravneni')}
                    />
                )}
                {showIdentifikaceUpload === EZadostPravoIdentifikace.SC ? (
                    RenderKopieDokladouTotoznostiUpload()
                ) : showIdentifikaceUpload === EZadostPravoIdentifikace.EL &&
                  (mode === 'C2' || mode === 'zadostEdit' ? isAmlzRequired : true) ? (
                    <>
                        <ButtonComponent
                            id="c2StahnoutBtn"
                            buttontext="FORMULARE_STAHNOUT_KPODPISU"
                            disabled={
                                (form.getFieldValue('typprihlaseni') === 'CERT' &&
                                    !fileList.length &&
                                    !personData?.pristup?.novy?.certdn) ||
                                mode === 'displayOnly' ||
                                ((mode === 'smsLogin' || isZadost) && !!dokladyTotozSoubory.length
                                    ? false
                                    : personData?.doplneno) ||
                                stavOdeslano
                            }
                            onClick={() => {
                                setDownloadSignature(true);
                            }}
                            style={{
                                marginTop: 14
                            }}
                            loading={downloadSignature}
                        />
                    </>
                ) : (
                    <></>
                )}
                {showIdentifikaceUpload === EZadostPravoIdentifikace.EL &&
                    !downloadSignature &&
                    RenderElektPodpisUpload()}

                {(mode === 'C2' || mode === 'zadostEdit') && (
                    <SelectComponent
                        name="stav"
                        labelParagraph="STAV"
                        isFormItem={true}
                        notRequired={true}
                        disabled={true}
                        defaultValue={personData?.stav}
                        data={c2stavSelectALL}
                        onChange={() => {
                            setForceRerender(pv => !pv);
                            form.validateFields(['stav']);
                        }}
                    />
                )}
                {isLegalEntity && !personData?.doplneno && <Paragraph text="AMLZ_C2_ADRESA_ERR" />}
                <div
                    style={{
                        marginTop: 10
                    }}
                >
                    <Row className="button-row">
                        {(mode === 'zadostEdit' || mode === 'C2' || mode === 'displayOnly') && (
                            <ButtonComponent
                                buttontext="ZPET"
                                id="ZadostoAgenduAmlzZpetOsobyBtn"
                                type="default"
                                onClick={() => {
                                    if (mode === 'displayOnly') {
                                        setPersonData && setPersonData(undefined);
                                        window.location.hash.includes(
                                            routePathEnum.EMITENT_ZASTUPUJICI_OSOBY_EDITACE
                                        ) &&
                                            navigateWorkaround(
                                                // eslint-disable-next-line max-len
                                                `/firma/${aktivniFirma?.iducet}${routePathEnum.EMITENT_ZASTUPUJICI_OSOBY}`
                                            );
                                    } else {
                                        onFinish(form.getFieldsValue(), 'backBtnPressed');
                                    }
                                    /*
                                    if (mode === 'zadostEdit') navigateWorkaround(-1);
                                    else if (mode === 'C2' && !amlzCheck ) {
                                        setPersonData && setPersonData(undefined);
                                        setRefetchTableData && setRefetchTableData(true);
                                    } else {
                                        setAmlzCheck(false);
                                        
                                    }*/
                                }}
                            />
                        )}
                        {mode === 'smsLogin' && (
                            <ButtonComponent
                                type="primary"
                                onClick={() => {
                                    onFinish(form.getFieldsValue(), 'saveOnly');
                                }}
                                id="ulozitbtn"
                                buttontext="ULOZIT"
                            />
                        )}
                        {showIdentifikaceUpload === EZadostPravoIdentifikace.EL &&
                            !!elPodpisSoubor.length &&
                            ((mode !== 'C2' && mode !== 'zadostEdit') || isAmlzRequired) &&
                            (identifikaceOsobyElhasFileUploaded ||
                                form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                                form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS ||
                                form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                                ((mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired)) && (
                                <ButtonComponent
                                    type="primary"
                                    onClick={() => {
                                        confirm({
                                            title: <TranslateText>AMLZ_OSOBA_ZMENA_CONFIRM_TEXT</TranslateText>,
                                            cancelText: <TranslateText>NE</TranslateText>,
                                            okText: <TranslateText>ANO</TranslateText>,
                                            onOk() {
                                                setElPodpisFileList([]);
                                                setPdfCheckError('');
                                                setElPodpisSoubor([]);
                                            }
                                        });
                                    }}
                                    id="CxemailBtn"
                                    buttontext="ZMENIT_UDAJE"
                                />
                            )}
                        {((form.getFieldValue('identifikaceosoby') === 'BI' &&
                            (!isAmlzRequired || personData?.doplneno) &&
                            (personData?.doplneno || mode === 'C2' || mode === 'zadostEdit')) ||
                            form.getFieldValue('identifikaceosoby') === 'EL' ||
                            form.getFieldValue('identifikaceosoby') === 'SC' ||
                            !form.getFieldValue('identifikaceosoby')) &&
                        mode !== 'displayOnly' ? (
                            <>
                                {!isAmlzRequired &&
                                    (personData?.stav === EStavZadostAmlz.DOPL ||
                                        personData?.stav === EStavZadostAmlz.UZIVCEKA ||
                                        personData?.stav === EStavZadostAmlz.UZIVDOPL ||
                                        personData?.stav === EStavZadostAmlz.CDCPKDOPL ||
                                        personData?.stav === EStavZadostAmlz.ROZP) &&
                                    (mode === 'C2' || mode === 'zadostEdit') &&
                                    !isLegalEntity && (
                                        <ButtonComponent
                                            type="primary"
                                            onClick={() => {
                                                form.validateFields([
                                                    'email',
                                                    'jmeno',
                                                    'prijmeni',
                                                    'telefon',
                                                    'pristupdepozitar',
                                                    ...(form.getFieldValue('pristupdepozitar') === 'ANO' &&
                                                    !personData?.pristup?.puvodni
                                                        ? ['typprihlaseni']
                                                        : [])
                                                ])
                                                    .then(() => {
                                                        if (personData?.stav !== EStavZadostAmlz.UZIVDOPL) {
                                                            setSaving(true);
                                                            onFinish(form.getFieldsValue(), 'sendMail');
                                                        } else {
                                                            setShowMailModal(true);
                                                        }
                                                    })
                                                    .catch(errorInfo => {
                                                        if (errorInfo.errorFields.length) {
                                                            form.scrollToField(errorInfo.errorFields[0].name[0]);
                                                        } else if (personData?.stav !== EStavZadostAmlz.UZIVDOPL) {
                                                            setSaving(true);
                                                            onFinish(form.getFieldsValue(), 'sendMail');
                                                        } else {
                                                            setShowMailModal(true);
                                                        }
                                                    });
                                            }}
                                            id="CxemailBtn"
                                            buttontext="AMLZ_POSLAT_EMAIL"
                                        />
                                    )}

                                <ButtonComponent
                                    type="primary"
                                    htmlType="button"
                                    onClick={() => validateBeforeSubmit()}
                                    id="CxPokracovatBtn"
                                    buttontext={mode === 'C2' || mode === 'zadostEdit' ? 'POTVRDIT_UDAJE' : 'ODESLAT'}
                                    extramessage={
                                        pdfCheckError && pdfCheckError !== 'pending'
                                            ? pdfCheckError === 'CERTOSOBA'
                                                ? 'SOUBOR_CERTOSOBA_PODPIS'
                                                : pdfCheckError === 'JINAOSOBA'
                                                  ? 'SOUBOR_JINAOSOBA_PODPIS'
                                                  : pdfCheckError === 'JINYSOUBOR'
                                                    ? 'SOUBOR_JINYSOUBOR_PODPIS'
                                                    : 'SOUBOR_CHYBA_PODPIS'
                                            : mode !== 'C2' &&
                                                mode !== 'zadostEdit' &&
                                                showIdentifikaceUpload === EZadostPravoIdentifikace.EL &&
                                                personData?.prilozenesoubory &&
                                                elPodpisFileList &&
                                                elPodpisFileList.length < 1
                                              ? 'FORMULARE_PODEPSANY_SOUBOR'
                                              : mode !== 'C2' &&
                                                  mode !== 'zadostEdit' &&
                                                  personData?.prilozenesoubory &&
                                                  showIdentifikaceUpload === EZadostPravoIdentifikace.SC &&
                                                  dokladyTotozFileList &&
                                                  dokladyTotozFileList.length < 1
                                                ? 'FORMULARE_DOKLADY_TOTOZNOSTI'
                                                : mode !== 'C2' &&
                                                    mode !== 'zadostEdit' &&
                                                    potvrzeniSoubory.length < 1 &&
                                                    showIdentifikaceUpload === EZadostPravoIdentifikace.SC
                                                  ? 'AMLZ_C2_PLATINSTRUKCE_ERR'
                                                  : !isBankidLoginOk
                                                    ? 'C2_BANKID_LOGIN_ERR'
                                                    : ''
                                    }
                                    disabled={
                                        (mode !== 'C2' &&
                                            mode !== 'zadostEdit' &&
                                            ((showIdentifikaceUpload === EZadostPravoIdentifikace.EL &&
                                                personData?.prilozenesoubory &&
                                                elPodpisFileList &&
                                                elPodpisFileList.length < 1) ||
                                                (personData?.prilozenesoubory &&
                                                    showIdentifikaceUpload === EZadostPravoIdentifikace.SC &&
                                                    dokladyTotozFileList &&
                                                    dokladyTotozFileList.length < 1) ||
                                                (potvrzeniSoubory.length < 1 &&
                                                    showIdentifikaceUpload === EZadostPravoIdentifikace.SC))) ||
                                        !!pdfCheckError ||
                                        !personData?.doplneno ||
                                        stavOdeslano ||
                                        !isBankidLoginOk ||
                                        showCertErr
                                    }
                                />
                            </>
                        ) : (
                            form.getFieldValue('identifikaceosoby') === 'BI' &&
                            mode !== 'displayOnly' &&
                            (isLegalEntity ? personData?.doplneno : true) && (
                                <ButtonComponent
                                    type="primary"
                                    htmlType="button"
                                    onClick={() => validateBeforeSubmit('redirectBiAmlz')}
                                    id="CbankidPokracovatBtn"
                                    buttontext="ZADOST_PRISTUP_BAKIND_BTN"
                                    extramessage={
                                        pdfCheckError && pdfCheckError !== 'pending'
                                            ? pdfCheckError === 'CERTOSOBA'
                                                ? 'SOUBOR_CERTOSOBA_PODPIS'
                                                : pdfCheckError === 'JINAOSOBA'
                                                  ? 'SOUBOR_JINAOSOBA_PODPIS'
                                                  : pdfCheckError === 'JINYSOUBOR'
                                                    ? 'SOUBOR_JINYSOUBOR_PODPIS'
                                                    : 'SOUBOR_CHYBA_PODPIS'
                                            : ''
                                    }
                                />
                            )
                        )}
                    </Row>
                </div>
                <Modal
                    title={<TranslateText>AMLZ_POSLAT_EMAIL</TranslateText>}
                    open={showMailModal}
                    onCancel={() => {
                        setShowMailModal(false);
                        setMailModalText(undefined);
                    }}
                    footer={[
                        <Row>
                            <ButtonComponent
                                id="akcionarHlasovaniSubmitBtn"
                                buttontext="POKRACOVAT"
                                onClick={() => {
                                    setSaving(true);
                                    onFinish(form.getFieldsValue(), 'sendMail');
                                }}
                            />
                        </Row>
                    ]}
                >
                    <Row>
                        <Input.TextArea
                            onChange={ev => setMailModalText(ev.target.value)}
                            rows={4}
                            defaultValue={personData?.vyjadreni}
                        />
                    </Row>
                </Modal>
            </FormWrapper>{' '}
        </LoadingWrapper>
    );
};

export default AgendaAmlzFormular;
